import React from 'react';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiInputBase-root': {
      padding: '6px 0 7px',      
     
    },
    '& .MuiInputBase-input': {
      padding: '6px 0 7px',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'rgba(0, 0, 0, 0.42)'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(0, 0, 0, 0.87)'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#004C6A'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#004C6A'
    },
    '& .MuiInputLabel-root': {
      lineHeight: 1,
    },
  
  },
}));

const helperUseStyles = makeStyles(() => ({
  helperText: {
    lineHeight: 1.1,
    letterSpacing: 0,
  }
}));

const Text = ({ input, inputId, handleInputs, value }) => {
  const classes = useStyles();
  const helperClasses = helperUseStyles();

  let required = input.hasOwnProperty('yup');
  
  if (input.hasOwnProperty('required')) {
    required = input.required;
  }

  return (
    <TextField
      variant="standard"
      classes={classes}
      error={input.error}
      key={inputId}
      name={inputId}
      value={value || ''}
      multiline
      minRows="4"
      required={required}
      label={input.label}
      helperText={input.error && input.errorMessage}
      onChange={handleInputs}
      FormHelperTextProps={{
        className: helperClasses.helperText
      }}
    />
  );
}

export default Text;